/*
 * @Author: your name
 * @Date: 2021-03-04 16:20:57
 * @LastEditTime: 2021-08-03 09:21:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\store\websocket\state.js
 */
/*
 * @Author: your name
 * @Date: 2021-03-04 16:20:57
 * @LastEditTime: 2021-08-03 09:19:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\store\websocket\state.js
 */
/*
 * @Author: your name
 * @Date: 2021-03-04 16:20:57
 * @LastEditTime: 2021-08-03 09:19:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\store\websocket\state.js
 */
const state = {
  myWebSocket: null, // webSocket连接对象
  timerMyWebSocketTimeOut: null, // 连接超时timer
  timerMyWebSocketHeart: null, // 心跳包timer
  timerMyWebSocketTimeInter:null,
  issueList: []
};

export default state;
